// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvtFullSize_wrapper__VkCIQ","qrBlock":"AdvtFullSize_qrBlock__BWWQ5","qrCode":"AdvtFullSize_qrCode__7qvBO"};